﻿import { echartSetOption } from './echarts-utils';

/* -------------------------------------------------------------------------- */
/*     Driver driving chart
/* -------------------------------------------------------------------------- */

const driverDrivingInit = () => {
  const { getColor, getData } = window.phoenix.utils;
  const chartEl = document.querySelector('.echart-driver-driving');

  if (chartEl) {
    const userOptions = getData(chartEl, 'echarts');
    const chart = window.echarts.init(chartEl);

    const getDefaultOptions = () => ({
      tooltip: {
        trigger: 'axis',
        axisPointer: { type: 'shadow' },
        padding: [7, 10],
        backgroundColor: getColor('body-highlight-bg'),
        borderColor: getColor('border-color'),
        textStyle: { color: getColor('light-text-emphasis') },
        borderWidth: 1,
        transitionDuration: 0,
        formatter: params => {
          return `<strong>${params[0].axisValue}:</strong> ${params[0].name}`;
        }
      },
      xAxis: {
        type: 'value',
        name: '%',
        nameLocation: 'middle',
        axisLine: {
          show: true,
          lineStyle: { color: getColor('tertiary-bg') }
        },
        axisTick: { show: true },
        axisLabel: { color: getColor('tertiary-color') },
        nameGap: 24,
        nameTextStyle: { color: getColor('tertiary-color') },
        splitLine: { show: false }
      },
      yAxis: {
        type: 'category',
        axisLine: {
          lineStyle: { color: getColor('tertiary-bg') }
        },
        axisLabel: {
          color: getColor('tertiary-color'),
          width: 140,
          overflow: 'break'
        },
        splitLine: {
          show: true,
          lineStyle: { color: getColor('secondary-bg') }
        },
        axisTick: { show: false },
        inverse: true
      },
      series: [
        {
          name: '',
          type: 'bar',
          lineStyle: { color: getColor('primary') },
          itemStyle: {
            color: getColor('primary'),
            barBorderRadius: [0, 3, 3, 0]
          },
          showSymbol: false,
          symbol: 'circle',
          smooth: false,
          hoverAnimation: true
        }
      ],
      grid: { right: '20', left: '150', top: '0', bottom: '50' }
    });
    echartSetOption(chart, userOptions, getDefaultOptions);

    if (window.chartReadyCallback) {
      window.chartReadyCallback(chart);
    }
  }
};

export default driverDrivingInit;
